import { Model } from '../model';
import { Paginated } from '../paginated';

export class ContactField extends Model {
  idField: string;
  placeholder: string;
  label: string;
  dataType: string;
  personalizable: boolean;
}

export class ContactFields extends Paginated {
  data: Array<ContactField>;
}
